@if (hasMoreThanOneEntites) {
  <div class="entite_dropdownlist">
    <select (change)="onEntiteChange($event)" class="entite_dropdownlist-select">
      @for (entite of entites(); track entite.id) {
        <option [value]="entite.id" [selected]="entite.id === idEntiteSelected()">
          {{entite.libelle}}
        </option>
      }
    </select>
  </div>
}
